import { Box } from "@mui/material";
import Tabs from "components/Tabs";
import { appActions } from "modules/app";
import { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";

import CoachApproachAppointments from "./CoachApproachAppointments";
import CoachApproachCompletedAppointments from "./CoachApproachCompletedAppointments";
import GraduationReport from "./Graduations";
import { REPORT_ROUTES } from "./routes";

const TCAReports = () => {
  const [tabValue, setTabValue] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const tabOptions = [
    { label: "Appointments", value: REPORT_ROUTES["appointments"] },
    { label: "Completed", value: REPORT_ROUTES["completed"] },
    // { label: "Graduation Report", value: REPORT_ROUTES["graduation-reports"] },
  ];

  const dispatch = useAppDispatch();

  dispatch(
    appActions.updatePageTitle({
      title: `TCA Reports`,
    })
  );

  useEffect(() => {
    const l = tabOptions.find((x) => location.pathname.includes(x.value));
    if (!l) {
      navigate(tabOptions[0].value);
    } else {
      setTabValue(l.value);
    }
  }, [location]);

  const handleChangeTab = (v: string) => {
    navigate(v);
    setTabValue(v);
  };

  return (
    <div className={"members-main"}>
      <Tabs value={tabValue} onChange={handleChangeTab} tabs={tabOptions} />
      <Box className="report-container">
        <Routes>
          <Route path={REPORT_ROUTES["reports"]} element={<CoachApproachAppointments />} />
          <Route path={REPORT_ROUTES["appointments"]} element={<CoachApproachAppointments />} />
          <Route
            path={REPORT_ROUTES["completed"]}
            element={<CoachApproachCompletedAppointments />}
          />
          <Route path={REPORT_ROUTES["graduation-reports"]} element={<GraduationReport />} />
        </Routes>
      </Box>
    </div>
  );
};

export default TCAReports;
